<div class="HeaderGroup" style="background-color: var(--app-surface); overflow: scroll;
    height: -webkit-fill-available;">
    <mat-toolbar color="primary" style="position: relative; z-index: 3">
        <span class="left">Produkt Übersicht</span>
        <button mat-icon-button class="open_in_new" matTooltip="in neuem Tab öffnen"
            (click)="openInNewTab(actualProduct.id)">
            <mat-icon>open_in_new</mat-icon>
        </button>

        <button mat-icon-button class="library_books" matTooltip="im Dialog öffnen"
            (click)="navigateToProduct(actualProduct.name,actualProduct)">
            <mat-icon>library_books</mat-icon>
        </button>
        <button mat-icon-button class="back" (click)="goBack.emit()" color="primary">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
    <div *ngIf="this.displaySpinner && actualProduct == undefined">
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!this.displaySpinner && actualProduct != undefined">
        <div class="containerSide">
            <app-image-slider [item]="this.actualProduct" [category]="'product'"></app-image-slider>
        </div>
        <div class="padding">
            <div class="grid-template">
                <div class="a">
                    <div style="display: flex; align-items: center">
                        <div class="pointer" style="width: 45px" (click)="
                                navigateToOrganisation(
                                    organisation.organisationId
                                )
                            ">
                            <app-image-slider [organisation]="this.organisation">
                            </app-image-slider>
                        </div>
                        <div style="padding: 1rem">
                            <h1 [class]="
                                    actualProduct?.name.length > 35
                                        ? 'wordellipsis'
                                        : ''
                                " style="margin: 0">
                                {{ actualProduct?.name }}
                            </h1>
                            <h3 class="pointer" [class]="
                                    actualProduct?.name.length > 35
                                        ? 'wordellipsis'
                                        : ''
                                " style="margin: 0" (click)="
                                    navigateToOrganisation(
                                        organisation.organisationId
                                    )
                                ">
                                {{ organisation?.organisationName }}
                            </h3>
                        </div>
                    </div>

                </div>
                <div class="b twocolumn-grid">
                    <div #colmn1 class="certificate-icon certificate-margin">
                        <app-star [rating]="actualProduct?.rating"
                            [ratingCount]="actualProduct?.ratingCount"></app-star>
                    </div>
                    <div #colmn2 class="certificate-icon">
                        <app-certificate-mini-display *ngIf="
                                actualProduct?.attributeCertificationCount &&
                                actualProduct?.attributeCertificationCount >
                                    0
                            " [certificateType]="'ATTRIBUTE_CERT'" [certCount]="
                                actualProduct?.attributeCertificationCount
                            ">
                        </app-certificate-mini-display>
                        <!---------------------->
                        <app-certificate-mini-display *ngIf="
                                actualProduct?.ptgCertificationCount &&
                                actualProduct?.ptgCertificationCount > 0
                            " [certificateType]="'PTG_CERT'" [certCount]="
                                actualProduct?.ptgCertificationCount
                            "></app-certificate-mini-display>
                        <!---------------------->
                        <app-certificate-mini-display *ngIf="
                                actualProduct?.toolchainCertificationCount &&
                                actualProduct?.toolchainCertificationCount >
                                    0
                            " [certificateType]="'TOOLCHAIN_CERT'" [certCount]="
                                actualProduct?.toolchainCertificationCount
                            ">
                        </app-certificate-mini-display>
                        <!---------------------->
                        <app-certificate-mini-display *ngIf="
                                actualProduct?.ptgsWhereAllMandatoryAttributesImplementedCount &&
                                actualProduct?.ptgsWhereAllMandatoryAttributesImplementedCount >
                                    0
                            " [certificateType]="'ATTRIBUTE_MANDATORY_CERT'" [certCount]="
                                actualProduct?.ptgsWhereAllMandatoryAttributesImplementedCount
                            ">
                        </app-certificate-mini-display>
                    </div>
                </div>
                <div class="c btn-grid">
                    <button [disabled]="organisation?.contacts.length < 1 ||
                        this.disabledFeatures " mat-raised-button color="primary" (click)="requestDemo()"
                        class="margin-right btn">
                        Demo anfragen
                    </button>

                    <button mat-raised-button class="margin-right btn" [disabled]="
                            this.actualProduct.url == null ||
                            this.actualProduct.url == undefined ||
                            this.actualProduct.url == ''
                        " mat-raised-button (click)="routeToWebsite()" color="primary">
                        Produktwebseite
                    </button>
                    <button mat-raised-button class="margin-right  btn" color="primary" [disabled]="
                            !userService.currentUser ||
                            hasUserReviewedProduct() ||
                            showWriteReview  || 
                            this.disabledFeatures
                        " (click)="goToBottom(rating)">
                        Produkt bewerten
                    </button>
                    <button [disabled]="organisation?.contacts.length < 1 || 
                    this.disabledFeatures" mat-raised-button color="primary" (click)="requestOffer()" class="btn"
                        [class]="disabledFeatures ? 'btn' : 'btnColorFull'">
                        Angebot anfragen
                    </button>
                </div>
            </div>
            <br />
            <span style="display: flex; opacity: 0.8">
                <p *ngIf="actualProduct?.category == 'APP'; else otherType" class="left" style="margin: 0">
                    Produktkategorie: APPLIKATION
                </p>

                <ng-template #otherType>
                    <p class="left" style="margin: 0">
                        Produktkategorie: {{ actualProduct?.category }}
                    </p>
                </ng-template>
                <p class="middle" style="margin: 0">
                    Seit
                    {{ actualProduct?.publishDate | humanReadableDate }} auf
                    BIMSWARM
                </p>
                <p class="right" style="margin: 0">
                    Letztes Update:
                    {{ actualProduct?.editDate | humanReadableDate }}
                </p>
            </span>
            <br />
            <mat-divider></mat-divider>
            <br />
            <mat-chip-list>
                <mat-chip *ngFor="let item of this.keywords">{{
                    item
                    }}</mat-chip>
            </mat-chip-list>
            <br />

            <h3>Produktbeschreibung</h3>
            <p class="word-wrap" [innerHTML]="actualProduct?.description"></p>
        </div>
    </div>
    <mat-tab-group *ngIf="!this.displaySpinner && actualProduct != undefined" style="flex: 1"
        [backgroundColor]="'primary'" class="tabGroup">
        <mat-tab label="Produkteigenschaften">
            <div *ngIf="this.actualProduct != null" class="featuretab paddingFull">
                <app-product-detail-display-feature [product]="this.actualProduct">
                </app-product-detail-display-feature>
            </div>
        </mat-tab>
        <mat-tab [disabled]="!(this.actualProduct.documentFileIds == null)  && 
            !this.disabledFeatures" label="Downloads">
            <div class="paddingFull clickable">
                <app-product-detail-display-downloads
                    [fileIds]="this.actualProduct.documentFileIds"></app-product-detail-display-downloads>
            </div>
        </mat-tab>
        <mat-tab label="Zertifikate">
            <div *ngIf="this.actualProduct != null" class="paddingFull">
                <app-product-detail-display-certificates [product]="this.actualProduct">
                </app-product-detail-display-certificates>
            </div>
        </mat-tab>
        <mat-tab label="Anbieter">
            <div *ngIf="this.actualProduct != null" class="paddingFull">
                <app-product-detail-display-organisation [organisation]="this.organisation">
                </app-product-detail-display-organisation>
            </div>
        </mat-tab>
        <mat-tab label="Bewertungen" [disabled]="!this.disabledFeatures">
            <div class="paddingFull">
                <div id="ratingPane" #rating></div>
                <app-marketplace-rating-extended [targetId]="actualProduct?.id" [reviewType]="reviewType"
                    [reviews]="reviews" [average]="average" [nrOfReviews]="nrOfReviews"
                    [showWriteReview]="showWriteReview" (reviewCloseEmitter)="showWriteReview = false"
                    (reviewOpenEmitter)="showWriteReview = true" (averageEmitter)="loadAverageScore()"
                    (statisticsEmitter)="loadReviewStatistic()"
                    (reviewEmitter)="loadReviews()"></app-marketplace-rating-extended>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
